import styled from 'styled-components';
import { typography, layout, transitions, breakpoints } from '../../theme';

export const Wrapper = styled.li`
  margin-bottom: ${props =>
    props.isActive ? `${layout.SPACING}rem` : `-14vw`};
  margin-top: ${props =>
    props.isActive ? `calc(14vw + ${layout.SPACING}rem)` : `0`};
  transition: margin ${transitions.PANES};

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media ${breakpoints.MOBILE__MQ} {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
    max-width: 60rem;
    transform-style: preserve-3d;
    width: 100%;
  }
`;

export const FrameWrapper = styled.div`
  position: relative;
  transition: transform ${transitions.PANES}, width ${transitions.PANES};
  transform: rotateX(${props => (props.isActive ? 0 : -45)}deg);
  transform-origin: center bottom;
  transform-style: preserve-3d;
  width: ${props => (props.isActive ? 60 : 34)}vw;

  @media ${breakpoints.MOBILE__MQ} {
    margin: 0 auto;
    transform: none;
    width: 100%;
  }

  a {
    border: none;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const Frame = styled.div`
  background: ${props => props.backgroundColor};
  border: currentColor solid 2px;
  border-radius: 6px;
  transition: background ${transitions.COLOR};
  overflow: hidden;
`;

export const Title = styled.h2`
  border-bottom: currentColor solid 2px;
  display: block;
  font-size: ${typography.FONT_SIZE__SMALL}rem;
  margin: 0;
  padding: 0 6px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
`;

export const Dots = styled.span`
  align-items: center;
  display: flex;
  font-size: ${typography.FONT_SIZE}rem;
  padding-right: 8px;
`;

export const Dot = styled.span`
  border: currentColor solid 2px;
  border-radius: 6px;
  height: 12px;
  margin-right: 6px;
  width: 12px;

  &:last-child {
    margin-right: 0;
  }
`;
